import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { SharedState } from 'shared/store';
import * as fromShared from 'shared/store/shared.store';

@Injectable()
export class InvestorGuard implements CanActivate {
    private isInvestor: boolean;

    constructor(private store: Store<SharedState>, private router: Router) {
        this.store.select(fromShared.selectUser).subscribe(user => (this.isInvestor = user && !user.isBanker));
    }

    public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {
        if (this.isInvestor) {
            return true;
        } else {
            // Send to default banker page
            this.router.navigate(['secure', 'customer-search']);
        }
    }
}
